import React from "react";
import Loader from 'react-loader-spinner'
// import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, isWhite, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import { FormBuilderObjects } from "../../variables/formBuilderData";
import HttpServices from "../../utils/Http.services";
import { e } from "mathjs";

class StagesSelectInput extends React.Component {
    state = {
        options: [],
        choosen: [],
        isLoading: false
    }

    componentDidMount() {
        // this.init(true)
        this.fetchFields()

    }


    componentDidUpdate(prevProps) {

        // if (this.props.params != prevProps.params) {
        //     this.init()
        // }

        // console.log(this.props.header?.information?.frame)

        if (this.props.header?.information?.frame != this.state?.frame || (this.props.header?.information?.frame && !this.state.frame)) {

            // console.log(this.props.header?.information?.frame)

            this.fetchFields()
        }
    }


    fetchFields = () => {

        // console.log("fetchFields")

        this.setState({ frame: this.props.header?.information?.frame })

        if (this.props.header?.information?.frame) {
            let body = { filter: {} }

            if (!Array.isArray(this.props.header?.information?.frame)) {
                body.filter._id = [this.props.header?.information?.frame]
            } else {
                body.filter._id = this.props.header?.information?.frame
            }

            // console.log("getFrame!", body)

            HttpServices.request('getFrames', body, (fetchResult, fetchError) => {

                // console.log(fetchResult, fetchError)

                this.setState({ isLoadingHeaders: false })
                if (fetchError) {
                    this.setState({ fetchError })
                    return
                }

                // let fields = fetchResult?.info?.fields

                // console.log(fetchResult.info)

                // let params =  []
                let myStages = []

                if (Array.isArray(fetchResult.info)) {

                    let info = this.props.header?.information

                    fetchResult.info.forEach(frame => {
                        // if (!myStages) {
                        //     myStages = { label: "View Record", value: 'record', fields: frame?.fields, info: fetchResult.info }
                        // } else {
                        // console.log(frame?.stages)
                        if (Array.isArray(frame?.stages)) {

                            frame.stages.forEach(frameStage => {

                                let found = false

                                myStages.forEach(stage => {

                                    // console.log(stage)
                                    if (info.nameAsValue) {
                                        if (checkTranslation(frameStage.name)?.toLowerCase() == checkTranslation(stage.name)?.toLowerCase()) {
                                            found = true
                                        }
                                    } else {
                                        if (frameStage.id == stage.id) {
                                            found = true
                                        }
                                    }
                                })

                                if (!found && frameStage.type != "trigger") {
                                    myStages.push(frameStage)
                                }

                            });
                        }
                        // myParams.fields = [...(myParams.fields ?? []), ...(frame?.fields ?? [])]
                        // }
                    });
                }

                // let myParams = { label: "View Record", value: 'record', fields: fetchResult.info?.fields, info: fetchResult.info }
                // console.log(myStages)
                this.setState({ stages: myStages }, () => {
                    this.init()
                })



            })
        }

    }

    init(mount) {
        // let refParams = Array.isArray(this.props.params) ? [...this.props.params] : []

        // if (this.state.myParams) {
        //     refParams.splice(0, 0, this.state.myParams)
        // }
        let stages = this.state.stages

        // // console.log(this.props.params)
        // if (refParams) {
        // let stages

        // let params = []
        let choosen = []

        let info = this.props.header?.information

        if (Array.isArray(this.props.data)) {
            stages.forEach(stage => {
                // let paramIsValid = false
                // let validTypes = this.props.header.information?.validTypes ?? null

                // if (item.fields) {
                //     item.fields.forEach(field => {

                //         if (!validTypes || validTypes.includes(field.type)) {

                //             if (!paramIsValid) {
                //                 paramIsValid = true
                //                 let param = { ...item }
                //                 param.fields = []
                //                 params.push(param)
                //             }
                //             let value = "{{" + checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label) + "}}"
                //             let title = checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label)


                // console.log(value)
                // console.log(this.props.data)
                if (info.nameAsValue) {
                    if (this.props.data.includes(stage.name)) {
                        choosen.push(stage)
                    }
                } else {
                    if (this.props.data.includes(stage.id)) {
                        choosen.push(stage)
                    }
                }


                // params[params.length - 1].fields.push(field)
                // }
                //     });
                // }
            });
        }
        // console.log(choosen)

        this.setState({ choosen })
        // let value = item ? "{{" + item.label + ' - ' + field.information?.label + "}}" : null
        // let title = item ? item.label + ' - ' + field.information?.label : null

        // }

    }



    toggleOpen = (open) => {
        let openState = open != null ? open : !this.state.isOpen

        if (openState) {
            this.fixedView.showView()
        } else {
            this.fixedView.hideView()
        }

        this.setState({ isOpen: openState })

    }



    changeValue = (item, selected, field) => {

        let info = this.props.header?.information

        let choosen = this.state.choosen

        if (selected) {
            for (let i = 0; i < choosen.length; i++) {

                if (info.nameAsValue) {
                    if (checkTranslation(choosen[i].name) == checkTranslation(item.name)) {
                        choosen.splice(i, 1)
                    }
                } else {
                    if (choosen[i].id == item.id) {
                        choosen.splice(i, 1)
                    }
                }
            }
        } else {
            choosen.push(item)
        }

        this.setState({ choosen }, () => {
            // if (!dontChangeValue) this.changeValue()
        })

        // let value = item ? "{{" + checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label) + "}}" : null
        // let title = item ? checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label) : null
        // console.log(e.target.value)
        // let value = e.target.value
        // if (value == '') {
        //     value = null
        // }
        // console.log('this.props.header.key',this.props.header.key)
        // console.log('e.target.value',e.target.value)
        let final
        choosen.forEach(element => {
            if (!final) {
                final = []
            }

            if (info.nameAsValue) {
                final.push(element.name)
            } else {
                final.push(element.id)
            }

            // final.push(element.name)
            // choosen.push((element.value))

        });

        // console.log("changeValue", item, final)

        this.props.changeValue(this.props.header.key, final, this.props.extra)
        // this.toggleOpen(false)
        // this.setState({ choosen: value ? { title, value } : null })
    }


    render() {
        // let dataValue = ''
        // if (this.props.data) {
        //     dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        // }
        let info = this.props.header?.information

        return (
            <div className='w-100' style={{ position: 'relative' }}>
                <div style={{ position: 'relative' }} ref={el => this.currentNode = el}  >
                    <div className="w-100" onClick={() => this.toggleOpen(true)}>

                        {this.props.header.information.placeholder && !this.state.choosen?.length && (
                            <div className="h-100 flexc w-100 cursor-pointer" style={{ top: 0, padding: '4px 0px 3px 0px' }}>
                                <p className={' mrd-1 mld-1 placeholder w-100 '}>{this.props.header.information.placeholder ? checkTextTranslation(this.props.header.information.placeholder) : translate('Select...')}</p>
                            </div>
                        )}

                        {this.state.choosen?.length > 0 && (

                            <div style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>

                                {this.state.choosen.map((prop, index) => {

                                    let backIsWhite = isWhite(prop.color?.background)

                                    return (
                                        <div key={prop.name} className="" style={{maxWidth:'100%', display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                            <div className="flexcc w-100" style={{ padding: 5, border: backIsWhite ? '1px solid #eee' : '1px solid transparent', background: prop.color?.background, color: prop.color?.text, borderRadius: 20, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>

                                                <button onClick={(e) => { e.stopPropagation(); this.changeValue(prop, true) }} className="br-20 p-1 flexcc mrd-1" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                                                    <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} alt="" />
                                                </button>


                                                <p style={{ whiteSpace: 'nowrap',textOverflow: 'ellipsis', overflow: 'hidden', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{checkTranslation(prop.name)}</p>

                                            </div>

                                        </div>
                                    )
                                })}

                            </div>
                        )}

                    </div>

                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={0} zIndex={15} xOffset={-2} rightAlign={false} width={250} maxWidth={250}>

                        <div className="w-100 br-8 py-2" style={{ backgroundColor: '#fff', boxShadow: '0px 0px 20px #10101020', maxHeight: 270, overflow: 'auto' }}>

                            <div className=" flexcb w-100 text-smaller text-start pt-1 px-2 pb-2" style={{ borderBottom: '1px solid #eee' }} >
                                <div className=' px-1'>
                                    {/* <img draggable={false} src={FormBuilderObjects[field.type]?.icon} className='br-20 mrd-3' width={20} style={{ filter: 'grayscale(0%)' }} /> */}
                                    <p className=" text-bold text-small">{translate("Select stages")}</p>
                                    {/* <p className=" text-smallest">{translate("Stage are listed and will be considered by their name. If stages with same name have different colors, you may see them by the color of one of them")}</p> */}

                                </div>

                                {/* <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' /> */}
                            </div>
                            <div className="w-100 pt-2">

                                {this.state.stages?.length == 0 && (
                                    <div className="py-2 px-2 text-small text-semibold text-center">
                                        <p>{translate("Found nothing")}</p>
                                    </div>
                                )}

                                {this.state.stages?.map((stage, index) => {

                                    let backIsWhite = isWhite(stage.color?.background)
                                    let selected = false
                                    for (var i = 0; i < this.state.choosen.length; i++) {

                                        if ((info.nameAsValue && checkTranslation(stage.name) == checkTranslation(this.state.choosen[i].name)) || (!info.nameAsValue && checkTranslation(stage.id) == checkTranslation(this.state.choosen[i].id))) {
                                            selected = true
                                        }
                                    }

                                    return (
                                        // <div className=" pt-2 pb-2 w-100 " key={item.value} style={{ borderBottom: '0px solid #eee' }}>
                                        //     <div className="px-1">
                                        //         <p draggable={false} className=" text-bold text-small">{translate(item.label)}</p>
                                        //     </div>
                                        //     <div className="px-1">
                                        //         {item.fields?.map((field, index) => {
                                        //             return (
                                        <button className="w-100 flexc py-1 px-2" key={stage.id} style={{ backgroundColor: selected ? '#78b2d020' : null }} onClick={() => { this.changeValue(stage, selected) }}>
                                            <div className='flexc br-20 ' style={{ padding: '6px 12px', border: (backIsWhite || selected) ? '1px solid #eee' : '1px solid transparent', background: stage.color?.background, color: stage.color?.text }} >
                                                <div className='flexc'>
                                                    {/* <img draggable={false} src={FormBuilderObjects[field.type]?.icon} className='br-20 mrd-3' width={20} style={{ filter: 'grayscale(0%)' }} alt="" /> */}
                                                    <p draggable={false} className=" text-semibold text-smaller">{checkTranslation(stage?.name)}</p>
                                                </div>

                                                {/* <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' /> */}

                                            </div>
                                        </button>
                                        //             )
                                        //         })}
                                        //     </div>

                                        // </div>
                                    )

                                })}
                            </div>
                        </div>
                    </FixedView>


                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: -2, right: 0 }}>
                            <Loader
                                type="ThreeDots"
                                color="#9ab"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>

            </div>
        );
    }
}

export default StagesSelectInput;
